import superagent from 'superagent';

export default async function getVideos() {
  let response = {};

  await superagent
    .get(`${process.env.REACT_APP_WEBSERVICE_MX}/getVideos`)
    .set('Content-Type', 'application/json')
    .then((res) => {
      response = res?.body || {};
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
